module.exports = __webpack_public_path__ + "img/60361e5.jpg";